import type {TicketIdFragment} from "app/gql/graphqlSchema";
import {IonBadge} from "@ionic/react";
import {styled} from "styled-components";

const LargeBadge = styled(IonBadge)`
  font-size: 0.9rem;
  padding: 0.25rem 0.5rem;
`;

interface Props {
  ticketId: TicketIdFragment;
}

export const TicketNumber = ({ticketId}: Props) => {
  return (
    <LargeBadge>
      {ticketId.clientId}-{ticketId.ticketId}
    </LargeBadge>
  );
};
